define([
	"dojo/topic",
	"csi/locale",
	"csi/monitor/_base",
	"csi/reflection",
	"csi/state/rootStore",
	"csi/types",
	"csi/xml"
], function(topic,locale,monitor,reflection, { sessionStore },types,xml) {

// published topics
	//	/csi/configuration/admin
	//	/csi/configuration/change
	//	/csi/configuration/refresh

	const STATUS_NONE = "None";
	const STATUS_WAITING = "Waiting";
	const STATUS_IN_PROGRESS = "InProgress";
	const STATUS_COMPLETED = "Success";
	const STATUS_INTERRUPTED = "Interrupted";
	const STATUS_FAILED = "Failed";
	const STATUS_MISSING = "Missing";

	const CONFIG_NODE_URL = "centric://REFLECTION/INSTANCE/_CS_Job/BOConfigurationUpdate";

	var _bAlreadyComplete = false;
	var _bFirstTime = true;
	var _result = null;

	function _getState() {
		// summary: return configuration job state
		return _result ? xml.enumGetText(_result.State) : null;
	}

	function canUpdateStatus() {
		// summary: determine if user allowed to update configuration
		return (_getState() != STATUS_WAITING) && (_getState() != STATUS_IN_PROGRESS);
	}

	function refresh() {
		// summary: return message indicating status of configuration
		var configState = _getState();
		var bError;
		var bProgress;
		var idRes;
		var params;
		var errorMessage;
		var errorException;

		if (configState == STATUS_MISSING) {
			bError = true;
			idRes = "ConfigStateMissing";
		} else if (sessionStore.adminOnly && _bAlreadyComplete) {
			// DE25314: Cannot run configuration update in Admin only mode
			// Do not Display the Admin Only Mode warning message during update configuration
			bError = true;
			idRes = "AdminOnlyMode_Invalid";
		} else if (_result && !_bAlreadyComplete && (configState != STATUS_NONE)) {
			var start = types.formatTime(_result.Started, types.FORMAT_DATETIME);
			var end = types.formatTime(_result.Ended, types.FORMAT_DATETIME);
			var progress = Math.round(_result.Progress * 100);

			idRes = "ConfigState" + configState;
			params = [start, end, locale.stringSubstitute(_result.ProgressMessage), progress];
			bError = (configState == STATUS_INTERRUPTED) || (configState == STATUS_FAILED);
			bProgress = (configState == STATUS_WAITING) || (configState == STATUS_IN_PROGRESS);
			errorMessage = _result.ErrorMessage;
			errorException = _result.ErrorException;
		}

		topic.publish("/csi/configuration/refresh", idRes ? locale.resource(idRes, params) : null, bProgress, bError, errorMessage, errorException);
	}

	/**
	 * Update status based on response and notify listeners
	 * @param {Node} resultNew 
	 */
	function _updateAndNotify(resultNew) {
		var resultOld = _result;
		var stateOld = _getState();
		_result = resultNew;
		var stateNew = _getState();

		// if getting first results and reflection model not initialized, then change state
		if (!reflection.isInitialized() && (!resultOld || (stateNew == STATUS_NONE))) {
			resultNew.State = "JobState:Missing";
			stateNew = STATUS_MISSING;
		}

		// track if still in complete state
		_bAlreadyComplete = !resultOld || ((stateNew == STATUS_COMPLETED) && (stateOld == STATUS_COMPLETED));

		// notify others that state has been refreshed
		refresh();

		var modified = false;
		if (resultOld && (stateNew == STATUS_COMPLETED) && (resultNew.Ended != resultOld.Ended)) {
			// use short interval so that completed status will be reset after a brief timeout
			topic.publish("/csi/configuration/change");
			modified = true;
		}

		// Always monitor the status. If the update job is in progress or waiting to be executed,
		// refresh more frequently (every 5 seconds); otherwise refresh every 5 minutes to detect changes started
		// outside of the current session.
		var interval = canUpdateStatus() ? 300000 : 5000;

		if (modified) {
			interval = 5000;
		}

		monitor.setPollingRefreshInterval(CONFIG_NODE_URL, interval);

		return modified;
	}

	/**
	 * Refresh the status of configuration
	 * @return {Deferred}
	 */
	function refreshStatus() {
		// first time start monitoring
		if (_bFirstTime) {
			_bFirstTime = false;
			monitor.onChangeNode(CONFIG_NODE_URL, _updateAndNotify);
		}

		// now refresh configuration status
		return monitor.refreshNode(CONFIG_NODE_URL);
	}
	
	return {
		canUpdateStatus,
		refreshStatus,
		refresh
	};
});